import vtkSampleFunction from './SampleFunction';

export default {
  vtkSampleFunction,
};
